<template>
  <div class="checks-index-container p-p-4">
    <div class="p-d-flex p-flex-column">
      <span>{{ __('Building') }}:</span>
      <i-override-dropdown
        optionLabel="FullAddress"
        :options="buildings"
        v-model="selectedBuilding"
        :filter="buildings.length > 10"
        @update:modelValue="handleBuildingChange"
      />
    </div>
    <div class="p-d-flex p-flex-column p-mt-3">
      <span>{{ __('Apartment') }}:</span>
      <i-override-dropdown
        optionLabel="UnitFullName"
        :options="filteredUnits"
        v-model="selectedUnit"
        :filter="filteredUnits.length > 10"
        @update:modelValue="handleUnitChange"
        :disabled="!selectedBuilding"
      />
    </div>
    <div class="p-d-flex p-flex-column p-mt-3">
      <span>{{ __('A tenant pays') }}:</span>
      <i-override-dropdown
        optionLabel="FullName"
        :options="filteredContacts"
        v-model="selectedContact"
        :filter="filteredContacts.length > 10"
        :disabled="!selectedUnit"
      />
    </div>

    <p-vue-button
      class="button p-button-rounded p-button-success add-contact p-mt-4"
      :label="__('Continue')"
      @click="goToFinancial"
      :disabled="!selectedContact"
    />
  </div>
</template>

<script>
import { checksService } from '@/services/checks.service'

export default {
  data() {
    return {
      buildings: [],
      units: [],
      contacts: [],
      selectedBuilding: null,
      selectedUnit: null,
      selectedContact: null,
    }
  },
  computed: {
    filteredUnits() {
      return this.selectedBuilding
        ? this.units.filter((unit) => unit.BID === this.selectedBuilding.BID)
        : this.units
    },
    filteredContacts() {
      if (this.selectedUnit) {
        return this.contacts.filter(
          (contact) => contact.UID === this.selectedUnit.UID
        )
      } else if (this.selectedBuilding) {
        return this.contacts.filter(
          (contact) => contact.BID === this.selectedBuilding.BID
        )
      }
      return this.contacts
    },
  },
  async created() {
    try {
      const checkListItems = await checksService.getChecksListData()
      this.buildings = checkListItems.Buildings
      this.units = checkListItems.Units
      this.contacts = checkListItems.Contacts
    } catch (error) {
      console.error('Error fetching check list data:', error)
      // Handle error (e.g., show error message to user)
    }
  },
  methods: {
    handleBuildingChange() {
      this.selectedUnit = null
      this.selectedContact = null
    },
    handleUnitChange() {
      this.selectedContact = this.filteredContacts[0]
    },
    goToFinancial() {
      if (this.selectedContact) {
        console.log("🚀 ~ goToFinancial ~ this.selectedContact:", this.selectedContact)
        
        this.$store.commit('setFinancialReportContact', this.selectedContact)
        this.$router.push(`/financial-report/${this.selectedContact.ContactID}`)
      }
    },
  },
}
</script>

<style>
/* Your existing styles here */
</style>
